const black = {
  red: 0,
  green: 0,
  blue: 0,
  alpha: 1,
};

function subtitle_conductor_global(subtitle, positions) {
  return {
    startRow: positions[0],
    startColumn: positions[1],
    rowData: [
      {
        values: {
          userEnteredValue: {
            stringValue: subtitle,
          },
          userEnteredFormat: {
            textFormat: {
              bold: true,
              foregroundColorStyle: {
                rgbColor: black,
              },
              fontSize: 12,
            },
            horizontalAlignment: "CENTER",
            verticalAlignment: "MIDDLE",
            wrapStrategy: "LEGACY_WRAP",
          },
        },
      },
    ],
  };
}

export { subtitle_conductor_global };
